"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@veeam/core");
var DatePeriodMenu_1 = require("./DatePeriodMenu");
var DatePeriodInteractor_1 = require("./DatePeriodInteractor");
var FilterSelector_1 = require("../FilterSelector");
var helpers_1 = require("../../helpers");
var icons_1 = require("../DatetimeInput/icons");
exports.DatePeriod = helpers_1.createUIElement('DatePeriod', function (_a, ref) {
    var className = _a.className, texts = _a.texts, _b = _a.value, value = _b === void 0 ? [] : _b, onChange = _a.onChange, _c = _a.startDatetime, startDatetime = _c === void 0 ? new Date(0) : _c, _d = _a.endDatetime, endDatetime = _d === void 0 ? new Date(9999, 11, 31) : _d, defaultInitDate = _a.defaultInitDate, defaultInitFromDate = _a.defaultInitFromDate, defaultInitToDate = _a.defaultInitToDate, disabled = _a.disabled, error = _a.error, size = _a.size, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "texts", "value", "onChange", "startDatetime", "endDatetime", "defaultInitDate", "defaultInitFromDate", "defaultInitToDate", "disabled", "error", "size", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    if (defaultInitToDate && defaultInitFromDate && defaultInitToDate < defaultInitFromDate) {
        console.warn('DatePeriod Error: the value of "defaultInitFromDate" property must be greater than the value of "defaultInitToDate" property.');
    }
    var rootRef = react_1.useRef(null);
    var buttonRef = ref || rootRef;
    var valueModel = core_1.useModelBuilder(value, [value]);
    var interactor = core_1.useInteractor(function () { return new DatePeriodInteractor_1.DatePeriodInteractor(valueModel, { onChange: onChange }, { texts: texts }); }).interactor;
    var controlTextValue = core_1.useModel(interactor.textValueModel).value;
    return (react_1.default.createElement(FilterSelector_1.FilterSelector, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-DatePeriod " + className, error: error, renderValueText: function () { return controlTextValue; }, renderIconBefore: function () { return react_1.default.createElement(icons_1.CalendarSvg, { disabled: disabled, error: error }); }, disabled: disabled, size: size, renderMenu: function (_a) {
            var deactivate = _a.deactivate;
            interactor.presenter = {
                hideMenu: deactivate
            };
            return (react_1.default.createElement(DatePeriodMenu_1.DatePeriodMenu, { texts: texts, value: valueModel.getValue(), startDatetime: startDatetime, endDatetime: endDatetime, defaultInitDate: defaultInitDate, defaultInitFromDate: defaultInitFromDate, defaultInitToDate: defaultInitToDate, onCancel: deactivate, onDone: interactor.didDone }));
        }, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: buttonRef, style: style })));
});
//# sourceMappingURL=DatePeriod.js.map